import { gql } from '@apollo/client'

export const CORE_SUBSCRIPTION_FIELDS = gql`
  fragment CoreSubscriptionFields on Subscription {
    primaryProduct {
      id
      key
      billingDateChangeable
      core
      uncancelable
      title
      details
      bundledPaidCalls
      uhc
      recurring
      requiresShipping
      includesCgm
      ownSensor
      uhc
      free
      interval {
        key
        description
        suffix
      }
      eligibleUpgradeProducts {
        id
        key
        ownSensor
        title
      }
      incompatibleAddons {
        id
      }
      bundledPaidCalls
      ehrSchedulingRule {
        appointmentKind
        chargeKind
        count
        key
        additionalPaidCallsAllowed
      }
      includedGoods {
        id
        key
        uhc
        recurring
        ehrSchedulingRule {
          appointmentKind
          chargeKind
          count
          key
          additionalPaidCallsAllowed
        }
      }
    }
    primaryPlan {
      stripeId
      amount
      product {
        id
      }
    }
    price
    discountedPrice
    id
    latestInvoice {
      id
    }
    stripeId
    subscribedAt
    startAt
    cancelAt
    paused
    commitmentEndAt
    currentPeriodStartAt
    currentPeriodEndAt
    resetBillingCycleAnchorAt
    trialEndAt
    resumesAt
    allowedPauseCycles
    status
    checkoutOptions {
      kind
    }
    uhcStoreSubscription {
      id
    }
  }
`
